import * as jsrsasign from "jsrsasign";

const isNotEmptyCheck = (data: any) => {
  return (
    data !== undefined && data !== "undefined" && data !== "" && data !== "null" && data !== null
  );
};

const setCookie = (name: string, value: string) => {
  document.cookie = name + "=" + value + "; Path=/;";
};

const deleteCookie = (name: string) => {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT;";
};

const getCookie = (cname: string) => {
  let ca, decodedCookie;
  const name = cname + "=";
  if (typeof document !== "undefined") {
    decodedCookie = decodeURIComponent(document.cookie);
    ca = decodedCookie.split(";");
    if (isNotEmptyCheck(ca) && ca.length) {
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          let reqCookieItem = c.substring(name.length, c.length);
          if (cname === "_t_") {
            reqCookieItem = reqCookieItem.substr(19, reqCookieItem.length);
          }
          return reqCookieItem;
        }
      }
    } else return "";
  }
};

const decodeJwtWithJsrs = (token: any) => {
  if (token) {
    try {
      const decodedToken: any = jsrsasign.KJUR.jws.JWS.parse(token);
      return decodedToken?.payloadObj;
    } catch (error) {
      console.log(error, "errorr");
    }
  }
};

const clearAllCookies = () => {
  const cookies = document.cookie.split("; ");
  for (const cookie of cookies) {
    const [name] = cookie.split("=");
    document.cookie = `${name}=; max-age=0; path=/;`;
  }
};

export { setCookie, deleteCookie, getCookie, decodeJwtWithJsrs, clearAllCookies };
